var load = require('./utils/load');


module.exports = load();



//////////////////
// WEBPACK FOOTER
// ./~/annogenerate/lib/index.js
// module id = 734
// module chunks = 0